import React from "react";
import { StyledContainer } from "./styles";
import Card from "..";

export default function ImageCard({
  x,
  y,
  content,
  width,
  height,
  id,
  selected,
  type,
  zoom,
  generating,
  index,
  autoHeight,
}) {

  return (
    <Card
      x={x}
      y={y}
      content={content}
      width={width}
      height={height}
      id={id}
      selected={selected}
      type={type}
      zoom={zoom}
      generating={generating}
      index={index}
      lockAspectRatio={true}
      generatable={false}
      autoHeight={autoHeight}
    >
      <StyledContainer>
        {!content &&
          <>Card errored!</>
        }

        {content && generating && <>Generating</>}

        {content && !generating && (
          <img
            draggable="false"
            src={content.url}
          />
        )}
      </StyledContainer>
    </Card>
  );
}
